<template>

	<div
		class="slider"
		:style="fundoSlider">

		<div
			v-if="parceiroConfig.sessoes.customization.campos.landPage.flgMaxWidth"
			class="overlay"
			:class="{ overlay_background: isOverlayActive }">
		
			<div style="display:flex; flex-direction: column">
		
				<land-page-header :backgroundTransparent="true" ></land-page-header>
		
				<land-page-search></land-page-search>
		
			</div>

			<div>

				<land-page-totals></land-page-totals>

			</div>

		</div>

		<div
			v-else
			class="overlay"
			:class="{ overlay_background: isOverlayActive }" >

			<land-page-header :backgroundTransparent="true" ></land-page-header>

			<land-page-search></land-page-search>

			<div>

				<land-page-totals></land-page-totals>

			</div>

		</div>

	</div>

</template>

<script>
import { mapState } from "vuex";
import mixins from "@/mixins/mixins";

import LandPageHeader from "./LandPageHeader";
import LandPageSearch from "./LandPageSearch";
import LandPageTotals from "./LandPageTotals";

export default {
	name: "LandPageSlider",

	components: { LandPageTotals, LandPageSearch, LandPageHeader },

	mixins: [mixins],

	computed: {
		...mapState({
			corPrimaria: (estado) => estado.corPrimaria,
			corSecundaria: (estado) => estado.corSecundaria
		}),

		fundoSlider() {
			let background = this.parceiro && this.parceiroConfig.sessoes.header.arquivos && this.parceiroConfig.sessoes.header.arquivos.length > 0 ?
				"url(" + this.parceiroConfig.sessoes.header.arquivos[0].arquivo + ")" :
				"url(" + require(`@/assets/images/background-blue.png`) + ")";

			return {
				"--fundoFull": background,

				"--fundoMobile": this.parceiro && this.parceiroConfig.sessoes.header.campos
					&& this.parceiroConfig.sessoes.header.campos.imagesMobile
					&& this.parceiroConfig.sessoes.header.campos.imagesMobile.length > 0 ?
					"url(" + this.parceiroConfig.sessoes.header.campos.imagesMobile[0].arquivo + ")" : background,

				"--coverOrStretch": this.parceiroConfig.sessoes.customization.campos.landPage.flgStretch ? "100% 100%" : "cover"
			};
		},

		isOverlayActive: function() {
			return this.parceiroConfig.sessoes.customization.campos.landPage.flgOverlay == undefined ? true : !this.parceiroConfig.sessoes.customization.campos.landPage.flgOverlay;
		}
	}
};
</script>

<style scoped lang="scss">
.slider {
	width: 100%;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	box-sizing: border-box;

	/* Set a specific height */
	min-height: 500px;

	/* Create the parallax scrolling effect */
	background-image: var(--fundoFull);
	background-size: var(--coverOrStretch);
	background-attachment: fixed;
	background-position: center center;
	background-repeat: no-repeat;
	@media only screen and (max-width: 1024px) {
		background-image: var(--fundoMobile);
		background-attachment: initial;
		background-size: 100% 100%;
	}
}
.overlay {
	content: "";
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	box-sizing: border-box;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;

	/* Set a specific height */
	min-height: 500px;

	/* Create the parallax scrolling effect */
	background-attachment: fixed;
}
.overlay_background {
	background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAG0lEQVQYV2NkYGD4z8DAwMgABXAGNgGwSgwVAFbmAgXQdISfAAAAAElFTkSuQmCC) repeat;
}
</style>
